import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';

import { EMPLOYERS } from 'RestAPIs/endpoints';
import { DeleteErrorResponse, useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditEmployersForm from './components/CreateEditEmployersForm';

import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import { useGetTableData } from './hooks/useGetTableData';
import showSnackbar, { showErrorSnackbar } from 'components/shared/Snackbar';

const Employers = () => {
  const { t } = useTranslation('common');
  const columns = useGetColumnDefs();
  const { data, isFetching, refetch } = useGetTableData();
  const { mutateAsync: deleteEmployer } = useDeleteById(EMPLOYERS, 'employee', {
    showErrorSnackbar: false,
    showSuccessSnackbar: true
  });

  const onDeleteClick = async (ids: number[]) => {
    try {
      await deleteEmployer(ids);
      refetch();
    } catch (error) {
      const err = error as AxiosError<DeleteErrorResponse>;
      if (
        err?.response?.status === 400 &&
        err.response.data?.error?.message?.includes('constraint_violation')
      ) {
        showSnackbar({
          message: t('employers.constraintViolation'),
          severity: 'error'
        });
      } else {
        showErrorSnackbar();
      }
    }
  };

  return (
    <TableCRUDLayout
      FormComponent={CreateEditEmployersForm}
      rows={data}
      loading={isFetching}
      columns={columns}
      getRowId={(row) => row.employerId}
      onDeleteClick={(ids) => onDeleteClick(ids as number[])}
      confirmationTitle={t('employers.confirmationTitle')}
      confirmationBody={t('employers.confirmationBody')}
      customCreateTitle={t('employers.drawerTitle.create')}
      customEditTitle={t('employers.drawerTitle.edit')}
    />
  );
};

export default Employers;
